interface HeroProps {
  search: string;
  setSearch: (v: string) => void;
  onSearch: () => void;
}

export default function Hero({ search, setSearch, onSearch }: HeroProps) {
  return (
    <section
      id="home"
      className="relative flex min-h-[92vh] w-full items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=A%20vibrant%20cel-shaded%20anime%20illustration%20of%20a%20stack%20of%20open%20comic%20books%20and%20floating%20pages%20in%20a%20warm%20orange%20and%20golden%20night%20sky%20filled%20with%20sparkles%20and%20paper%20planes%2C%20energetic%20young%20manga%20reading%20atmosphere%2C%20rich%20flat%20color%20background%2C%20high%20detail&width=1600&height=900&seq=hero-manhua-01&orientation=landscape)",
        }}
        aria-hidden="true"
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/40 to-background-950/70"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-20 pt-32 md:px-6 md:pb-28 md:pt-40">
        <div className="max-w-3xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-background-100/30 bg-background-50/10 px-4 py-1.5 text-sm font-medium text-background-100 backdrop-blur-sm">
            <i className="ri-download-cloud-2-line text-base" aria-hidden="true"></i>
            下载缓存 · 离线畅读 · 全集打包收藏
          </p>

          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
            洒洒漫画网
            <span className="mt-3 block text-2xl font-bold md:text-4xl">
              缓存漫画，随时随地无网络也能畅读
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            热门漫画全集打包离线收藏，一键下载缓存到本地。用洒洒漫画网缓存喜欢的作品，
            通勤、旅行、飞机上都能随时翻看，真正实现离线看漫画自由。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#how"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-primary-400"
            >
              <i className="ri-download-2-line text-lg" aria-hidden="true"></i>
              开始下载缓存
            </a>
            <a
              href="#comics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 bg-background-50/10 px-6 py-3.5 text-base font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
            >
              浏览热门漫画
              <i className="ri-arrow-right-line text-lg" aria-hidden="true"></i>
            </a>
          </div>

          <form
            className="mt-10 flex max-w-xl flex-col gap-2 sm:flex-row sm:items-center sm:rounded-md sm:bg-background-50 sm:p-1.5 sm:shadow-soft"
            onSubmit={(e) => {
              e.preventDefault();
              onSearch();
            }}
            role="search"
          >
            <label htmlFor="hero-search" className="sr-only">
              搜索漫画
            </label>
            <div className="flex items-center gap-2 rounded-md bg-background-50 px-4 py-3 sm:flex-1 sm:bg-transparent sm:py-1.5">
              <i className="ri-search-line text-base text-foreground-500" aria-hidden="true"></i>
              <input
                id="hero-search"
                type="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="搜索漫画名称或类型，如：热血、星海尽头…"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:py-2.5"
            >
              搜索漫画
            </button>
          </form>
        </div>

        <div className="mt-14 grid max-w-3xl grid-cols-3 gap-4">
          {[
            { num: "10万+", label: "已缓存作品" },
            { num: "98%", label: "离线畅读满意度" },
            { num: "60+", label: "支持主题类型" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-100/20 bg-background-50/10 p-4 text-center backdrop-blur-sm"
            >
              <p className="font-heading text-2xl font-black text-accent-400 md:text-3xl">
                {s.num}
              </p>
              <p className="mt-1 text-xs text-background-100/80 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}